module.exports = __webpack_public_path__ + "static/media/videocall.d56b37fd.png";